export default () => ({
    searchingData: {
        per_page: 50,
        page: 1,
        search: {
            user: '',
            log_category: '',
            log_level: '',
            log_id: '',
            datetime_start: '',
            datetime_end: ''
        },
        sort: [
            {
                key: 'datetime',
                asc: false
            }
        ],
        aggregate_day_range: 90
    }
});
